import { NSARouterMakerResult } from "namirasoft-account-react";
import { ClassifierClassInputRow } from "namirasoft-inference";
import { IBaseComponentProps, NSBox, NSBoxString, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { InferenceRouterProps } from "../InferenceRouterProps";

export interface ClassifierClassLineProps extends IBaseComponentProps, NSARouterMakerResult, InferenceRouterProps
{
    index: number;
    deletable: boolean;
    onDelete: () => void;
    onChanged?: (value: ClassifierClassInputRow | null) => void;
}

export default class ClassifierClassLine extends Component<ClassifierClassLineProps>
{
    static IS_DIRTY(value: ClassifierClassInputRow | null): boolean
    {
        if (value && value.name)
            return true;
        return false;
    }

    private NSBoxString_Name = createRef<NSBoxString>();
    private NSBoxString_Description = createRef<NSBoxString>();

    constructor(props: ClassifierClassLineProps)
    {
        super(props);
        this.getValue = this.getValue.bind(this);
        this.isDirty = this.isDirty.bind(this);
        this.onChanged = this.onChanged.bind(this);
    }

    getValue(checkError: boolean = false): ClassifierClassInputRow | null
    {
        let name = this.NSBoxString_Name.current?.getValue(checkError) ?? null;
        let description = this.NSBoxString_Description.current?.getValue(checkError) ?? null;
        if (!name)
            return null;
        return { name: name!, description };
    }

    setValue(value: ClassifierClassInputRow)
    {
        this.NSBoxString_Name.current?.setValue(value.name);
        this.NSBoxString_Description.current?.setValue(value.description);
    }

    isDirty(): boolean
    {
        return ClassifierClassLine.IS_DIRTY(this.getValue(false));
    }

    private onChanged()
    {
        if (this.props.onChanged)
            this.props.onChanged(this.getValue(false));
    }

    override render()
    {
        return (
            <NSRow style={{ ...this.props.style, flexWrap: "nowrap" }}>
                <NSBoxString
                    ref={this.NSBoxString_Name}
                    title={`Name ${this.props.index + 1}`}
                    required
                    onChanged={this.onChanged}
                    info={{ link: "https://namirasoft.com/inference/console-guide/classifier/#field-classes" }}
                />
                <NSBoxString
                    ref={this.NSBoxString_Description}
                    title="Description"
                    required={false}
                    onChanged={this.onChanged}
                    info={{ link: "https://namirasoft.com/inference/console-guide/classifier/#field-classes" }}
                    menu={{
                        builtin: { delete: { enabled: this.props.deletable, onDelete: () => { this.props.onDelete(); } } },
                        items: []
                    }}
                    style={{ width: NSBox.width.double }}
                />
            </NSRow>
        );
    }
}